/* ============================================================
   1. PAGE LOAD — Progress Bar Init
   ============================================================ */

$(document).ready(function () {
  initShippingBar();
});

function initShippingBar() {
  var progressBar = $(".cart-drawer__progress");
  if (progressBar.length) {
    var progress = progressBar.attr("data-progress") || 0;

    progressBar.css("width", "0%");

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        progressBar.css("width", progress + "%");
      });
    });
  }
}

/* ============================================================
   2. AJAX RE-RENDER — Progress Bar Update
   ============================================================ */

function updateShippingBar(oldWrapperHtml) {
  var progressBar = $(".cart-drawer__progress");
  if (!progressBar.length) return;

  var newProgress = progressBar.attr("data-progress") || 0;

  var oldProgressBar = $(".cart-drawer__progress", oldWrapperHtml);
  var oldProgress = oldProgressBar.attr("data-progress") || 0;

  progressBar.css("transition", "none").css("width", oldProgress + "%");

  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      progressBar.css("transition", "").css("width", newProgress + "%");
    });
  });
}

/* ============================================================
   3. SECTION RE-RENDERING — Cart Drawer + Header Cart Count
   ============================================================ */

function sectionRedering() {
  var oldContainer = $(".cart-drawer__inner").clone();

  fetch("?section_id=cart-drawer")
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".cart-drawer__inner", cart__html);
      $(".cart-drawer__inner").replaceWith(render__html);

      updateShippingBar(oldContainer);
    });

  fetch("?section_id=header")
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);

      var newMobiCount = $(".header__cart-mobi p", cart__html).text();
      $(".header__cart-mobi p").text(newMobiCount);

      var newDeskCount = $(".header__cart-desk em", cart__html).text();
      $(".header__cart-desk em").text(newDeskCount);
    });
}

/* ============================================================
   4. ADD TO CART — Add-on Product Quick-Add
   ============================================================ */

function addToCartDrawer(event, el) {
  event.preventDefault();
  var variantId = $(el).attr("data-variant-id");

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      id: variantId,
      quantity: 1,
    },
    dataType: "json",
    success: function (response) {
      $("body").addClass("cart-drawer-show");
      sectionRedering();
    },
    error: function (err) {
      console.log("Error adding product to cart:", err);
    },
  });
}



/* ============================================================
   5. QUANTITY CONTROL — +/- Buttons (Input based)
   ============================================================ */

function increment(el) {
  var input = el.previousElementSibling;
  var value = parseInt($(input).val());
  value = isNaN(value) ? 0 : value;
  value++;
  $(input).val(value);
  changeQuantity(input);
}

function decrement(el) {
  var input = el.nextElementSibling;
  var value = parseInt($(input).val());
  if (value > 1) {
    value--;
    $(input).val(value);
    changeQuantity(input);
  }
}

/* ============================================================
   6. QUANTITY UPDATE — Common Function
   ============================================================ */

function changeQuantity(input) {
  var quantity = $(input).val();
  var data_line = $(input).attr("data-line");

  var data = {
    line: data_line,
    quantity: quantity,
  };

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: data,
    success: function (data) {
      sectionRedering();
    },
    error: function (err) {
      console.log("Error from quantity update");
    },
  });
}

/* ============================================================
   7. REMOVE ITEM
   ============================================================ */

function removeItem(event, el) {
  event.preventDefault();
  var data_line = $(el).attr("data-line");

  var deleteData = {
    line: data_line,
    quantity: 0,
  };

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: deleteData,
    success: function (data) {
      sectionRedering();
    },
  });
}

/* ============================================================
   8. CART DRAWER OPEN / CLOSE
   ============================================================ */
$(document).on("click", ".new-header__cart", function (e) {
  e.preventDefault();
  $("body").addClass("cart-drawer-show");
});

$(document).on("click", ".cart-drawer__close, .cart-overlay", function () {
  $("body").removeClass("cart-drawer-show");
});